import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API() + 'cennik/';

export default {

    pobierzSprawdzenieKonfiguracjiCennikow(dataOd, dataDo, rodz) {
        return axios({
            method: 'get',
            url: URL + 'pSprawdzCennikiZakDat?dataOd=' + dataOd + '&dataDo=' + dataDo, //+ '&rodz=' + rodz,
        });
    },

    pobierzDatyCennikow(idTr, rodz) {
        return axios({
            method: 'get',
            url: URL + 'data?idTr=' + idTr + '&rodz=' + rodz,
        });
    },

    getCennik(idTr, rodz, data) {
        let url;
        if (Boolean(data)) {
            url = URL + 'trasa/data?idTr=' + idTr + '&rodz=' + rodz + '&dataOd=' + data
        }
        else {
            url = URL + 'trasa/data?idTr=' + idTr + '&rodz=' + rodz
        }

        return axios({
            method: 'get',
            url: url,
        });
    },

    addCena(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editCena(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    generujCennikDlaWszystkichAktywnych(wspolczynnik, datado) {
        return axios({
            method: 'get',
            url: URL + 'pZrobCennikTot?dataOd=' + datado + '&wsp=' + wspolczynnik,
        });
    },

    generujCennikDlaKonkretnejTrasy(wspolczynnik, datado, rodz, trasa) {
        return axios({
            method: 'get',
            url: URL + 'pZrobCennik?dataOd=' + datado + '&rodz=' + rodz + '&idTr=' + trasa + '&wsp=' + wspolczynnik,
        });
    },

    przepiszNaCennikPowrotny(dataCennika, rodz, trasa) {
        return axios({
            method: 'get',
            url: URL + 'pCennikPrzepiszNaTrPow?dataCennika=' + dataCennika + '&rodz=' + rodz + '&idTr=' + trasa
        });
    },
    usunDanyCennik(idTr, data, rodz) {
        return axios({
                url: URL + 'usunCennik/'+idTr+'/'+data+'/'+rodz,
                method: 'delete',
            }
        )
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/cenyBiletow/CennikBiletowService.js